/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".counter-title[_ngcontent-%COMP%]{color:#383838;font-size:10pt;line-height:20px;margin-left:4px}.counter[_ngcontent-%COMP%]{border-radius:90px;padding:2px 5px;text-align:center;display:table;margin:2px 3px;cursor:pointer}.new[_ngcontent-%COMP%]{background:#ff64a4}.negotiate[_ngcontent-%COMP%]{background:#ff673e}.rejected[_ngcontent-%COMP%]{background:#c3c3c3}.held[_ngcontent-%COMP%]{background:#b68ee9}.accepted[_ngcontent-%COMP%]{background:#17f000}"];
export { styles as styles };
